export const SERVER_URL = "https://54.185.24.125:3100";

export const API_STATUS = {
  IDLE: "idle",
  PENDING: "pending",
  ERROR: "error",
  SUCCESS: "success",
};
